/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Link from "@mui/material/Link";

import { colors } from "@dotnet/telematics-design-system";

import Tooltip from "../../../components/Tooltip/Tooltip";
import { IconLinkProps } from "../types";

const IconLink = ({ link, tooltip, icon: Icon, dataTestId }: IconLinkProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip disableTouchListener title={t(`Auth##${tooltip}`)} size="medium">
      <Link
        data-testid={dataTestId}
        target="_blank"
        rel="noreferrer"
        href={link}
        underline="hover"
        css={css({
          display: "inline-flex",
          color: colors.gray700,

          "&:hover": {
            color: colors.blue700
          }
        })}
      >
        <Icon />
      </Link>
    </Tooltip>
  );
};

export default IconLink;
